
const barbers = [
  {
    name: 'Reywoo.cutz',
    service: 'Barber',
    link: 'https://booksy.com/en-us/1463452_reywoo-cutz_barber-shop_38165_annandale?do=invite&_branch_match_id=1474152167382605182&utm_medium=profile_share_from_profile_completeness&_branch_referrer=H4sIAAAAAAAAA8soKSkottLXT07J0UvKz88urtRLzs%2FVz%2FX2LqisCjPKjEiyrytKTUstKsrMS49PKsovL04tsnXOKMrPTQUACuwQYjwAAAA%3D',
    img: 'reyy.png'
  },
    {
    name: 'CutByMo',
    service: 'Barber',
    link: 'https://booksy.com/en-us/1452556_cutbymo_barber-shop_38165_annandale?do=invite&_branch_match_id=1474152167382605182&utm_medium=profile_share_from_profile&_branch_referrer=H4sIAAAAAAAAA8soKSkottLXT07J0UvKz88urtRLzs%2FVL3HKjPJLSolKj0iyrytKTUstKsrMS49PKsovL04tsnXOKMrPTQUApr9LWjwAAAA%3D',
    img: 'cutbymo.png'
  },
  {
    name: '44cuttz',
    service: 'Barber',
    link: 'https://booksy.com/en-us/1682229_44cutz_barber-shop_38165_annandale?do=invite&_branch_match_id=1573001689111756822&utm_medium=profile_share_from_profile&_branch_referrer=H4sIAAAAAAAAA8soKSkottLXT07J0UvKz88urtRLzs%2FV94lIynS1SCzLMEiyrytKTUstKsrMS49PKsovL04tsnXOKMrPTQUAwnCNkTwAAAA%3D',
    img: '44.png'
  },
  {
    name: 'MoniBlends',
    service: 'Barber',
    link: 'https://booksy.com/en-us/1182253_moniblends_barber-shop_38165_annandale?do=invite&_branch_match_id=1474152167382605182&utm_medium=merchant_customer_invite&_branch_referrer=H4sIAAAAAAAAA8soKSkottLXT07J0UvKz88urtRLzs%2FV9%2FYOd04tzfNPjkiyrytKTUstKsrMS49PKsovL04tsnXOKMrPTQUA8MDIozwAAAA%3D',
    img: '/monii.png'
  },
    {
    name: 'Hecutz',
    service: 'Barber',
    link: 'https://booksy.com/en-us/1598477_hecutz_barber-shop_38165_annandale?do=invite&_branch_match_id=1474152167382605182&utm_medium=profile_share_from_profile&_branch_referrer=H4sIAAAAAAAAA8soKSkottLXT07J0UvKz88urtRLzs%2FVd7XMyAnLcMpOikiyrytKTUstKsrMS49PKsovL04tsnXOKMrPTQUANrC9DzwAAAA%3D',
    img: 'hecut.png'
  },
  {
    name: 'Izzcuts_',
    service: 'Barber',
    link: 'https://booksy.com/en-us/1600746_izzcutz_barber-shop_38165_annandale?do=invite&_branch_match_id=1474152167382605182&utm_medium=profile_share_from_profile&_branch_referrer=H4sIAAAAAAAAA8soKSkottLXT07J0UvKz88urtRLzs%2FVdwoLSwn1CLFMi0iyrytKTUstKsrMS49PKsovL04tsnXOKMrPTQUARGl9%2BjwAAAA%3D',
    img: 'izz.png'
  },
  {
    name: "Desoki_cuts",
    service: "Barber",
    link: 'https://booksy.com/en-us/1776168_desoki-cuts_barber-shop_38165_annandale?do=invite&_branch_match_id=1573001689111756822&utm_medium=profile_share_from_registration&_branch_referrer=H4sIAAAAAAAAA8soKSkottLXT07J0UvKz88urtRLzs%2FVr4jycPap9DdPN06yrytKTUstKsrMS49PKsovL04tsnXOKMrPTQUAGitztjwAAAA%3D',
  },
  {
    name: 'Moneybcutz',
    service: 'Barber',
    link: 'https://booksy.com/en-us/instant-experiences/widget/1552975?instant_experiences_enabled=true&ig_ix=true&fbclid=PAdGRleANTvIlleHRuA2FlbQIxMQABp24zXNdmXtgiGpNbLGKpPKSut1OPBZi185IN3XXzpB2zJx6jSdlLLGxbvq4t_aem_EspPeb_n0WKyPnnn7r9HWg',
  },

  {
    name: 'OneWayHairstyles',
    service: 'HairStylist',
    link: 'https://onewayhairstyles.as.me/schedule/ad561e6d',
    img: 'nidall.png'
  },
  {
    name: 'BraidsByBetty',
    service: 'HairStylist',
    link: 'https://booksy.com/en-us/dl/show-business/1600265',
    img: 'betty.png'
  },

];

export default function Services() {
  const barbersList = barbers.filter(b => b.service === 'Barber');
  const hairstylistsList = barbers.filter(b => b.service === 'HairStylist');

  return (
    <>

    {/* Barbers Section */}
<section id="barbers" className="services-section">
  <h2>Our Barbers</h2>
  <div className="services-grid">
    {barbersList.map(({ name, service, link, img }) => (
      <div key={name} className="service-card">
        {img && <img src={img} alt={name} className="profile-pic" />}
        <h3>{name}</h3>
        <p>{service}</p>
        <a href={link} target="_blank" rel="noopener noreferrer" className="book-button">
          Book Now
        </a>
      </div>
    ))}
  </div>

</section>
      

      {/* Hairstylists Section */}
      <section id="hairstylists" className="services-section">
        <h2>Our Hairstylists</h2>
        <div className="services-grid">
          {hairstylistsList.map(({ name, service, link, img }) => (
            <div key={name} className="service-card">
              {img && <img src={img} alt={name} className="profile-pic" />}
              <h3>{name}</h3>
              <p>{service}</p>
              <a href={link} target="_blank" rel="noopener noreferrer" className="book-button">
                Book Now
              </a>
            </div>
          ))}
        </div>
      </section>

      

      {/* Testimonials Section */}
<section className="testimonials">
  <h2>What Clients Say</h2>

  <div className="testimonials-container">
    {/* Testimonials Text */}
    <div className="testimonials-text">
      <blockquote>Best barbers in the DMV work here!!" – Fahad W.</blockquote>
      <blockquote>The shop is super clean and modern, and all the equipment looks brand new. Moni greeted me with great energy and made me feel right at home even offered a refreshing drink!" – Moayed H.</blockquote>
    </div>

    {/* Collage Next to Text */}
    <div className="testimonial-collage">
      <img src="/sudan.jpeg" alt="pic" />
      <img src="/wallphotos.png" alt="pic" />
    </div>
  </div>
</section>

    </>

    
  );

  
}


